import styled from '@emotion/styled'
import { css, keyframes } from '@emotion/react'

const primaryButtonPulse = keyframes`
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(255, 204, 0, 0);
  }

  40% {
    box-shadow: 0 0 0 4px rgba(255, 204, 0, 0.45);
  }
`

export const Card = styled.div<{ elevated?: boolean }>`
  position: fixed;
  z-index: ${({ elevated }) => (elevated ? 10051 : 10001)};
  width: min(360px, calc(100vw - 32px));
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  overflow: hidden;
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 20px 0;
`

export const HeaderTopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`

export const BlockedInteractionDangerNotice = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  margin: 0;
  padding: 8px 10px;
  border: 1px solid var(--foundation-border-negative-default, #f54337);
  border-radius: var(--border-radius-medium, 8px);
  background: var(--foundation-bg-negative-secondary, #fdecea);
  color: var(--foundation-txt-negative, #8b1a12);
  font-size: 11px;
  font-weight: 600;
  line-height: 1.35;
`

export const SkippedStepInfoNotice = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  margin: 0;
  padding: 8px 10px;
  border: 1px solid #f0c36d;
  border-radius: var(--border-radius-medium, 8px);
  background: #fff8e8;
  color: #8a5a00;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.35;
`

export const RouteTourLabel = styled.span`
  color: #8a6d3b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`

export const StepMetaRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`

export const StepLabel = styled.span`
  color: #f5a623;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`

export const Badge = styled.span`
  background: #fff3d6;
  color: #c77700;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 8px;
  border-radius: 999px;
  flex-shrink: 0;
`

export const ImageArea = styled.div`
  height: 140px;
  margin-top: 12px;
  background: linear-gradient(135deg, #fff8e1 0%, #ffe082 100%);
`

export const Image = styled.img`
  width: 100%;
  height: 140px;
  object-fit: cover;
  display: block;
`

export const Content = styled.div`
  padding: 16px 20px 0;
`

export const Title = styled.h2`
  margin: 0 0 8px;
  color: #1a1a1a;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
`

export const Body = styled.p`
  margin: 0;
  color: #616161;
  font-size: 14px;
  line-height: 1.55;
`

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px 20px;
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const GhostButton = styled.button`
  border: none;
  background: transparent;
  color: #616161;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 8px 0;
`

export const SecondaryButton = styled.button`
  border: none;
  border-radius: 8px;
  background: #e8e8e8;
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 8px 14px;
`

export const PrimaryButton = styled.button<{ $pulseTrigger?: number }>`
  border: none;
  border-radius: 8px;
  background: #ffcc00;
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  padding: 8px 16px;
  animation: ${({ $pulseTrigger = 0 }) =>
    $pulseTrigger > 0
      ? css`
          ${primaryButtonPulse} 0.55s ease-out
        `
      : 'none'};
`
